import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=023eaee6&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=ts&"
export * from "./TextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=023eaee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023eaee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023eaee6')) {
      api.createRecord('023eaee6', component.options)
    } else {
      api.reload('023eaee6', component.options)
    }
    module.hot.accept("./TextEditor.vue?vue&type=template&id=023eaee6&scoped=true&", function () {
      api.rerender('023eaee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/inputs/TextEditor.vue"
export default component.exports